// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT DIRECTLY.

export enum RegistrationStatus {
    NOT_CREATED,
    LIVE,
    PAUSED,
    CLOSED

}
export default RegistrationStatus
